import { User } from '../models/user.models';
import { BaseService } from './base.service';
import { Thread } from '../models/thread.model';

export default class ThreadsService extends BaseService {
  /////////////////////////////////////////////////////////////////
  /***************          Threads         **********************/
  /////////////////////////////////////////////////////////////////

  public async getThreads(teamId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/team/${teamId}/threads`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async createThread(payload: Thread, teamId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(`${this.backendUrl}/team/${teamId}/threads`, payload, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  /////////////////////////////////////////////////////////////////
  /***************           Thread         **********************/
  /////////////////////////////////////////////////////////////////

  public async getThread(teamId: any, threadId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.get(`${this.backendUrl}/team/${teamId}/thread/${threadId}`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async updateThread(payload: Thread, teamId: any, threadId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.put(`${this.backendUrl}/team/${teamId}/thread/${threadId}`, payload, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  public async deleteThread(teamId: any, threadId: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.delete(`${this.backendUrl}/team/${teamId}/thread/${threadId}`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }

  /////////////////////////////////////////////////////////////////
  /***************           Thread Reply         ****************/
  /////////////////////////////////////////////////////////////////

  public async postReply(message: string, id: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);

    return this.axios.post(
      `${this.backendUrl}/thread/${id}/thread-replies`,
      { message: message },
      {
        headers: {
          'x-access-token': user.token,
        },
      }
    );
  }

  public async deleteReply(threadId: any, id: any) {
    const user: User = JSON.parse(window.localStorage.getItem('user') as string);
    return this.axios.delete(`${this.backendUrl}/thread/${threadId}/thread-reply/${id}`, {
      headers: {
        'x-access-token': user.token,
      },
    });
  }
}
